import React, { useState, useEffect } from 'react';
import { Button, Typography, Box, Modal } from '@material-ui/core';

const TimeoutModal = ({ open, countdownSeconds, onStay, onTimeout }) => {
    const [timeLeft, setTimeLeft] = useState(countdownSeconds);

    useEffect(() => {
        if (!open) {
            setTimeLeft(countdownSeconds);
            return;
        }

        if (timeLeft === 0) {
            onTimeout();
            return;
        }

        const timer = setTimeout(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [open, timeLeft, onTimeout, countdownSeconds]);

    return (
        <Modal
            open={open}
            aria-labelledby="timeout-modal-title"
            aria-describedby="timeout-modal-description"
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                style={{
                    background: 'black',
                    borderRadius: '16px',
                    padding: '32px',
                    border: '1px solid #333',
                    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.8)',
                    textAlign: 'center',
                    color: 'white',
                    maxWidth: '430px',
                    width: '90%',
                }}
            >
                <Typography id="timeout-modal-title" variant="h5" gutterBottom style={{ color: '#ecf0f1', fontWeight: 'bold' }}>
                    Are you still there?
                </Typography>
                <Typography id="timeout-modal-description" variant="body1" gutterBottom style={{ marginBottom: '24px', color: 'white' }}>
                    Your session will time out due to inactivity in:
                </Typography>
                <Box style={{ width: '70%', margin: '16px auto', textAlign: 'left' }}>
                    <Typography variant="h3" style={{ fontWeight: 'bold', color: 'white' }}>
                        {timeLeft} seconds
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onStay}
                    style={{
                        marginTop: '24px',
                        borderRadius: '8px',
                        padding: '12px 32px',
                        textTransform: 'none',
                        fontSize: '1.1rem',
                        fontWeight: 'bold'
                    }}
                >
                    Yes, I'm still here
                </Button>
            </Box>
        </Modal>
    );
};

export default TimeoutModal;
